module.exports = __webpack_public_path__ + "img/f8888de.png";